import chroma from "chroma-js";

const MuiDataGrid: any = {
  styleOverrides: {
    root: {
      border: `1px solid ${chroma("#334b69").darken(3).css()}`,
      borderColor: "none",
      "& .datagrid-theme--Confirm": {
        backgroundColor: "#223a1f",
      },
      "& .datagrid-theme--Canceled": {
        backgroundImage:
          "linear-gradient(45deg, #3b2f33 25%, #4a3239 25%, #4a3239 50%, #3b2f33 50%, #3b2f33 75%, #4a3239 75%, #4a3239 100%)",
        backgroundSize: "56.57px 56.57px",
      },
      "& .datagrid-theme--Validate": {
        backgroundColor: "#484129",
      },
      "& .datagrid-theme--Delete": {
        backgroundColor: "#5a3f3f",
      },
      "& .MuiDataGrid-row:hover, & .MuiDataGrid-row:active": {
        backgroundColor: "#101010",
      },
    },
    columnHeaders: {
      backgroundColor: "#212F41",
      color: "#bdbdbd",
      borderColor: chroma("#334b69").darken(3).css(),
      borderBottom: "none",
    },
    columnHeader: {
      borderBottom: `1px solid ${chroma("#334b69").darken(3).css()}`,
    },
    columnHeaderTitle: { fontWeight: 900, textTransform: "uppercase" },
    footerContainer: {
      backgroundColor: "#212F41",
      borderTop: "1px solid",
      borderTopColor: "#102238 !important",
      color: "#bdbdbd",
      minHeight: "38px",
      height: "38px",
    },
    cell: {
      color: "#dddddd",
      borderColor: "#656565",
      fontSize: "0.9em",
    },
  },
};

export default MuiDataGrid;
